import React from "react";
import BadgeTooltip from "./BadgeTooltip";

const WarningsBadge = ({ warnings }) => {
  if (!warnings || !warnings.length) return null;

  const trigger = (
    <div className="code_badge__container">
      <div className="code_badge__indicator code_badge__indicator--warning" />
      <div className="t--sm">{warnings.length}</div>
    </div>
  );

  return (
    <BadgeTooltip trigger={trigger} rowCount={Math.min(warnings.length, 5)}>
      {warnings.map((code) => (
        <div key={code} className="flex align-items-center gap--4">
          <div className="code_badge__indicator code_badge__indicator--warning" />
          <div className="t--md">{code}</div>
        </div>
      ))}
    </BadgeTooltip>
  );
};

export default WarningsBadge;
